import image1 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';

const Data_ValePreOp = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Pre-operational inspections are a critical part of safe work in mining, but they can be difficult to
                      train consistently at scale. New operators often have limited time with equipment before entering the
                      field, and training environments can't always recreate the real pace, pressure, and consequences of
                      missed hazards.
                      <br />
                      <br />
                      Vale needed a way to strengthen inspection readiness and standardize learning by giving workers more
                      opportunities to practice identifying issues, following correct inspection, and building confidence
                      before they step onto site.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The challenge was building a realistic learning experience that mirrors how inspections happen in the
                      field-while keeping it easy to repeat and deploy at scale. The training needed to reflect real
                      equipment conditions, common issues, and the exact steps operators are expected to follow, including
                      documentation and decision-making under time constraints.
                      <br />
                      <br />
                      The solution also needed to reinforce consistency across different learners and shift teams, helping
                      ensure inspections are thorough, repeatable, and aligned with Vale's safety standards.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    Practice the inspection before the shift begins.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      Vale Pre-Op is an immersive training experience developed to help operators strengthen pre-operational
                      inspection skills through realistic practice. By simulating equipment walkarounds and inspection steps,
                      the experience allows learners to identify hazards, recognize abnormal conditions, and follow proper
                      procedures in a controlled environment.
                      <br />
                      <br />
                      The result is a repeatable training tool that supports more consistent inspections and improves worker
                      readiness before they begin operating equipment on site.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Designed for Consistency</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      The experience was built to reinforce a consistent inspection routine-helping learners build the right
                      habits and mental checklist. By giving workers more repetitions in a realistic environment, training can
                      strengthen knowledge retention and reduce variability between new and experienced operators.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Vale Pre-Op project screenshot 7" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Vale Pre-Op project screenshot 8" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Innovation & Engagement</h2>

                  <div className="paragraph dark-1">
                    <p>
                      Vale Pre-Op brings inspection training closer to real conditions by allowing learners to practice
                      walkarounds, identify hazards, and verify equipment readiness through guided, hands-on interaction.
                      Scenarios are designed to reinforce safe decision-making, highlight common inspection misses, and build
                      confidence through repetition-without placing workers or equipment at risk.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>Realistic pre-operational inspection flow and walkaround routine</li>
                      <li>Hazard identification and "what's wrong" recognition in context</li>
                      <li>Guided learning designed to build consistent inspection habits</li>
                      <li>Repeatable practice without taking operational equipment offline</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Vale Pre-Op project screenshot 9" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      Vale Pre-Op supports stronger inspection readiness by giving operators a safe, repeatable way to
                      practice the steps, decisions, and hazard recognition that matter most before entering the field.
                      <br />
                      <br />
                      By reinforcing consistency and increasing practice opportunities, the experience helps reduce missed
                      issues, improves confidence in inspection routines, and strengthens alignment with Vale's safety
                      standards across learners and teams.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="heading heading-medium light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>Vale Canada</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">WEBSITE</h4>
                    <div className="paragraph light-1">
                      <p><a href="https://vale.com/sudbury" target="_blank" rel="noreferrer">
                          www.vale.com/sudbury
                        </a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_ValePreOp;


